module.exports = __webpack_public_path__ + "img/collection-play.a5ca3cab.svg";